module.exports = __webpack_public_path__ + "img/button_foreground_company.10260ba9.png";